<template>
  <v-card class="d-flex flex-column px-3">
    <div class="d-flex flex-row justify-space-between align-center">
      <div class="text-h6">{{ productName }}</div>
      <v-btn icon @click="onDelete">
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-row justify-space-between align-center">
      <div class="date-text">{{ dateString }}</div>
      <div>
        <v-chip v-if="!isPrice" x-small class="mx-1"><v-icon small>mdi-currency-eur-off</v-icon></v-chip>
        <v-chip v-if="isPrice" x-small class="mx-1">
          <div class="price-text">
            {{currency.hasLeftPosition() ? currency.symbol : ''}}
            {{ productPrice }}
            {{currency.hasRightPosition() ? currency.symbol : ''}}
          </div>
        </v-chip>
        <v-chip v-if="isSpecial" x-small class="mx-1"><v-icon small>mdi-star</v-icon></v-chip>
        <v-chip v-if="isRanked" x-small class="mx-1"><div class="price-text">#1</div></v-chip>
      </div>
    </div>
  </v-card>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { MapGetters } from '@core/helpers/decorators';
import { ProductBoost } from '../models';

@Component
@MapGetters(['managedProductList', 'currency'])
export default class ProductBoostCard extends Vue {
  @Prop({ type: ProductBoost, required: true }) productBoost;

  get productName() {
    return this.managedProductList.find((product) => product.guid === this.productBoost.productGuid)?.commercial_name;
  }

  get productPrice() {
    return this.productBoost.price;
  }

  get isPrice() {
    return this.productPrice !== null;
  }

  get isSpecial() {
    return this.productBoost.isSpecialBoosted;
  }

  get isRanked() {
    return this.productBoost.isRankBoosted;
  }

  get dateString() {
    return `${this.productBoost.startDate.toLocaleDateString()} - ${this.productBoost.endDate.toLocaleDateString()}`;
  }

  onDelete() {
    this.$emit('delete');
  }
}

</script>

<style scoped>
.price-text {
  font-size: 12px;
  color: #545454;
  font-weight: bold;
}
.date-text{
  font-size: 14px;
}
</style>
